<script>
  import { MenuItemGroup } from 'element-ui'
  export default {
    name:'ElMenuItemGroup',
    extends:MenuItemGroup
  }
</script>
